export var ShopQueryType;
(function (ShopQueryType) {
    ShopQueryType["Filtered"] = "Filtered";
})(ShopQueryType || (ShopQueryType = {}));
export var Retention;
(function (Retention) {
    Retention[Retention["Forever"] = 0] = "Forever";
    Retention[Retention["Discard"] = 1] = "Discard";
    Retention[Retention["TTL"] = 2] = "TTL";
})(Retention || (Retention = {}));
export var MultiTicketType;
(function (MultiTicketType) {
    MultiTicketType[MultiTicketType["Single"] = 0] = "Single";
    MultiTicketType[MultiTicketType["HackerFare"] = 1] = "HackerFare";
    MultiTicketType[MultiTicketType["VirtualInterline"] = 2] = "VirtualInterline";
})(MultiTicketType || (MultiTicketType = {}));
//# sourceMappingURL=shop-query.js.map